import _ from 'lodash';
import { connect } from 'react-redux';
import { search, remove } from '../../modules/ocr/ocrIngestionResult';
import { bindActionCreators } from 'redux';
import { showErrors } from '../../modules/general';

const mapStateToProps = (state) => {
	let ocrIngestionResults;
	if (state.lists.ocrIngestionResultIds) {
		ocrIngestionResults = _.map(
			state.lists.ocrIngestionResultIds,
			(id) => state.maps.ocrIngestionResult[id]
		);
	}

	return {
		ocrIngestionResults,
		authUser: state.auth.authUser,
		userMap: state.maps.user,
		resourceMap: state.maps.resource,
		ocrIngestionDocumentMap: state.maps.ocrIngestionDocument,
		ocrGuideMap: state.maps.ocrGuide,

		carrierMap: state.maps.carrier,
		supplierMap: state.maps.supplier,
		terminalMap: state.maps.terminal,
		stationMap: state.maps.station,
		stationInvoiceMap: state.maps.stationInvoice,
		stationDeliveryMap: state.maps.stationDelivery,
		rackTransferMap: state.maps.rackTransfer,
		bulkCustomerMap: state.maps.bulkCustomer,
		bulkDeliveryMap: state.maps.bulkDelivery,
	};
};
const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			ocrIngestionResultSearch: search,
			ocrIngestionResultRemove: remove,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
